import type { ReactNode } from 'react';

import { CheckCircleFilledIcon, ExclamationCircleIcon } from '@/components/icons';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export type AlertBoxType = 'error' | 'success' | 'warning';

export type AlertBoxProps = {
  type: AlertBoxType;
  title?: ReactNode;
  children: ReactNode;
};

export const AlertBox = ({ type, title, children }: AlertBoxProps) => {
  const wrapperClassName =
    'alert rounded-sm grid grid-cols-[auto_1fr] items-start gap-3 ' +
    (type === 'error' ? 'alert-error' : type === 'success' ? 'alert-success' : 'alert-warning');

  const iconClassName =
    'w-5 h-5 ' +
    (type === 'error' ? 'icon-error' : type === 'success' ? 'icon-success' : 'icon-warning');

  return (
    <div role="alert" className={wrapperClassName}>
      <div className="-mt-px">
        {type === 'error' ? (
          <ExclamationCircleIcon className={iconClassName} />
        ) : type === 'success' ? (
          <CheckCircleFilledIcon className={iconClassName} />
        ) : type === 'warning' ? (
          <ExclamationTriangleIcon className={iconClassName} />
        ) : null}
      </div>

      <div className="flex flex-col gap-2">
        {title && <div className="text-sm font-bold">{title}</div>}
        <div className="text-sm alert-description wrap-anywhere">{children}</div>
      </div>
    </div>
  );
};
